// @flow
/**
 * Security selectors
 **/
import { createSelector } from "reselect";
import { Map } from "immutable";

const getPublic = (state: Map<string, any>) => {
  return state.get("publicApp");
};

const getScrollPercentage = createSelector(
  getPublic,
  (publicApp: Map<string, any>) => {
    return publicApp.get("scrollPercentage");
  }
);

const isShowScroll = createSelector(
  getPublic,
  (publicApp: Map<string, any>) => {
    return publicApp.get("showScroll");
  }
);

const isPersistent = createSelector(
  getPublic,
  (publicApp: Map<string, any>) => {
    return publicApp.get("persistent");
  }
);

export { getScrollPercentage, isShowScroll, isPersistent };
